// @ts-ignore package has no types
import HtmlParser from "react-html-parser";
import { T } from "@transifex/react";
import { Accordion } from "storybook/components/accordion";
import { RiskSummary } from "../../../../../components/risk-summary";
import { useRiskReport } from "context/risk-report";
import { ReportContainer } from "../../../styles";
import { SectionContent } from "../../styles";

const pagesToExclude = ["page2", "page3"];

export function RiskResultsSection() {
  const { error, reportHtml } = useRiskReport();

  const Report = () => (
    <ReportContainer role="article" className="notranslate">
      {HtmlParser(reportHtml, {
        transform: (node: any) =>
          pagesToExclude.includes(node.attribs?.id) ? null : undefined,
      })}
    </ReportContainer>
  );

  return (
    <SectionContent>
      <RiskSummary error={error} />
      <Accordion
        theme="default"
        title={
          <div className="accordionTitle">
            <T _str="Report preview" />
          </div>
        }
        previewContent={<Report />}
      >
        <Report />
      </Accordion>
    </SectionContent>
  );
}
